.characterGrid {
	display: grid;
	margin: 0 1.2rem;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	grid-auto-rows: min-content;
	gap: 12px;
	/* padding-bottom: 24px; */
}

.snippetContainer {
	position: relative;
	width: 100%;
	min-height: 0;
	aspect-ratio: 1 / 1;

	border: 1px solid var(--color-accent);
	background: transparent;
	color: inherit;
	font: inherit;
	text-align: inherit;
	padding: 0;
	display: block;
}

.snippetContainer:hover {
	border: 6px solid var(--color-accent);
	cursor: pointer;
}

.title {
	position: absolute;
	top: 0px;
	left: 0px;
	margin: 0;
	padding: 2px;
}

.footer {
	position: absolute;
	bottom: 0px;
	left: 0px;
	margin: 0;
	padding: 2px;
}

.spriteWrapper {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	box-sizing: border-box;
	z-index: -1;
}

.spriteContainer {
	width: 100%;
	height: 100%;
	object-fit: contain;
	image-rendering: pixelated;
	display: block;
}
